import { gql } from '@apollo/client/core';

// Add more deal attributes here if needed
export const externalUpdateDeal = gql`
  mutation externalUpdateDeal($dealId: ID, $tempInfoId: ID, $data: ExternalDealInputType!) {
    externalUpdateDeal(dealId: $dealId, tempInfoId: $tempInfoId, data: $data) {
      id
    }
  }
`;

export const dealAdvisors = gql`
  query dealAdvisors($dealId: ID) {
    dealAdvisors(dealId: $dealId) {
      setter {
        name
      }
      closer {
        id
        name
        photo_url
      }
      funding_clerk {
        name
        photo_url
      }
      title_clerk {
        name
        photo_url
      }
    }
  }
`;

export const totalCompletedDeals = gql`
  query totalCompletedDeals {
    totalCompletedDeals
  }
`;
